import React from 'react';
import CTA from 'components/CTA';
import ReadMoreLess from 'components/ReadMoreLess';
import styles from './side.module.scss';

const Side = ({
  description,
  title,
  collapse,
  isMarkdown,
  callToActions,
  backgroundColor,
}) => {
  return (
    <div className={styles.sideBySide}>
      {title && (
        <div className={styles.headingSection}>
          <h2>{title}</h2>
        </div>
      )}

      <div>
        {collapse ? (
          <ReadMoreLess
            content={description}
            isMarkdown={isMarkdown}
            shadowColor={backgroundColor || '#f5f5f5'}
          />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: description }}></div>
        )}
      </div>

      {callToActions?.length && (
        <div>
          <CTA
            callToActions={callToActions}
            extraStyle={`${styles.appTransparentRedButton}`}
          />
        </div>
      )}
    </div>
  );
};

export default Side;
